import Model from '@/plugins/sdk/resources/Asset/Manufacturer/Model'

export default class extends Model {
  static name = 'assetmanufacturer_model'
}
